import { useContext } from "react";

import { NavbarContext } from "../utils/navbar";

export function useNavbarContext() {
  return useContext(NavbarContext);
}
